import React from "react";

const LoadingBar =(props)=>{
    return (
      <>
        <div className={`loadingBarBox ${props.theme==="dark"?"bg-dark":""} fixed-top`}>
        {props.loadingBar
        &&
          <div className="loadingBar" id='loadingBarDiv'></div>
        }
          </div>
      </>
    )
}

export default LoadingBar